import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-new-roof-cost-how-it-works',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './new-roof-cost-how-it-works.component.html',
  styleUrl: './new-roof-cost-how-it-works.component.scss',
})
export class NewRoofCostHowItWorksComponent {
  @Input() step1ZipCode = '';
  @Output() step1Click = new EventEmitter<void>();

  readonly steps = [
    {
      icon: 'pin.svg',
      title: 'Enter your zip code',
      description:
        'We use your zip code to pull real local pricing data from roofing contractors near you',
      color: 'var(--brand-rust, #bf7039)',
    },
    {
      icon: 'roof-icon.svg',
      title: 'We scan your roof',
      description:
        "A few questions about your roof's material and current state, along with detailed measurements from satellite imagery, help us provide your personalized options.",
      color: 'var(--brand-glacier, #4f8fa3)',
    },
    {
      icon: 'files.svg',
      title: 'See your personalized options',
      description:
        'Browse pricing, reviews, and current promotions from vetted roofing contractors near you.',
      color: 'var(--brand-olive, #9d9e37)',
    },
  ];

  onStep1Keydown(e: Event): void {
    e.preventDefault();
    this.onStep1CardClick();
  }

  onStep1CardClick(): void {
    this.step1Click.emit();
  }
}
